import React, { useEffect, useState } from 'react';

/**
 * PlaymobilHupalupa2026: PLAYMOBIL × HUPALUPA Store reklam çalışmaları, 12 Ağustos – 18 Ekim 2026.
 * Route: /reports/playmobil-hupalupa-2026 (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 15 slayt, 16:9, apple.com tasarım dili. PLAYMOBIL ekibiyle toplantı (21 Eki) için;
 * hupalupa-performans-2026 hattından. Veri dondurulmuş (deck-data.json), yeniden üretmek:
 *   node src/pages/playmobil-hupalupa-2026/build.js
 *
 * 🔑 "PDF olarak indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P
 * slaytları tek sayfaya kırpar; düğmeyi dışarı taşıma.
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 *
 * HTML modülü ~80KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function PlaymobilHupalupa2026() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('../playmobilHupalupaHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="PLAYMOBIL · HUPALUPA Store reklam çalışmaları"
      srcDoc={html}
      style={fill}
    />
  );
}
